import { EStationPricingOption, EConnectorIdentifier, IBusinessCurrency } from '../types';

export interface IFilterStations {
    lng: number;
    lat: number;
    cursor?: number;
    search?: string;
    reload: boolean;
    ids?: string[];
}
export interface ILocation {
    _id?: string;
    name?: string;
    description?: string;
    phoneNumber?: string;
    email?: string;
    address: {
        street_1: string;
        street_2?: string;
        city: string;
        country: string;
        province: string;
        zip: string;
    };
    website?: string;
    location?: {
        type: string;
        coordinates: number[];
    };
    isHidden?: boolean;
    images?: string[];
    isCommercial?: boolean;
    connectorIdentifier?: EConnectorIdentifier;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface ICountry {
    currency: string;
}

export interface IUser {
    country: ICountry;
    stripe?: {
        isReadyForIncomingPayments?: boolean;
    };
}

export interface IStation {
    qrEnabled: boolean;
    online: boolean;
    status: EStationStatus;
    mode: 'Active' | 'Inactive';
    _id: string;
    identity: string;
    business: IBusiness;
    model: string;
    distance: number;
    connectors: IStationConnector[];
    isBusinessEnabled: boolean;
    stationLocation: ILocation;
    chargePointSerialNumber: string;
    /** @deprecated */
    tariff?: ITariff;
    stationPosition: number;
    user?: IUser;
    minimalChargeAmount?: number;
    /** @deprecated */
    currency?: string;
    /** @deprecated */
    city: string;
    /** @deprecated */
    address: string;
}

export interface IStationResponse {
    data: IStation;
}

export interface ITariff {
    pricingOption: EStationPricingOption;
    priceForHour?: number;
    priceForKwh?: number;
    priceIdle?: number;
    securityDepositAmount?: number;
    idleFee?: {
        enabled: boolean;
        graceMinutes: number;
        price: number;
    };
}

export interface IBusiness {
    _id: string;
    address: string;
    city: string;
    description: string;
    name: string;
    phoneNumber: string;
    site: string;
    email: string;
    website: string;
    workingHours: string;
    country: string;
    abbreviation: string;
    currency: IBusinessCurrency;
    pricingOption: EStationPricingOption;
    /* @deprecated */
    enabled: boolean;
    priceForHour?: number;
    priceForKwh?: number;
    priceIdle: number;
    stationPosition: number;
}

export interface IStationConnector {
    errorCode: string;
    /** @deprecated */
    id: number;
    power: number;
    status: EStationStatus;
    charge: string | null;
    mode?: 'Operative' | 'Inoperative' | string;
    type: string;
    maxPower: number;
    _id: string;
    tariff?: ITariff;
    qrCode: {
        shortCode: string;
        url: string;
    };
}

export enum EStationStatus {
    AVAILABLE = 'Available',
    PREPARING = 'Preparing',
    CHARGING = 'Charging',
    SUSPENDED_EV = 'SuspendedEV',
    SUSPENDED_EVSE = 'SuspendedEVSE',
    FINISHING = 'Finishing',
    RESERVED = 'Reserved',
    UNAVAILABLE = 'Unavailable',
    FAULTED = 'Faulted',
}

export const NO_IDLE_STATUSES: (EStationStatus | undefined)[] = [
    EStationStatus.AVAILABLE,
    EStationStatus.UNAVAILABLE,
    EStationStatus.FAULTED,
];
